import React from "react";
export const TaskGroupScreen = () => {
  return <h1>TaskGroup</h1>;
};
